import React, { useEffect, useState } from 'react'
import { MultilineTextField, Separator, TextField } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useStoryManager } from '../../../../../providers/StoryProvider'

export default function StoryTextForm() {
  const [t] = useTranslation()
  const { pendingEdits, setPendingEdits, setSaveHandler, commitEdits, isStoryValid, storyState, characterLimits } =
    useStoryManager()
  const { title, description, storyId } = pendingEdits || {}

  const [titleFieldValue, setTitleFieldValue] = useState(title || storyState?.title || '')
  const [descriptionFieldValue, setDescriptionFieldValue] = useState(description || '')

  const { maxTitleCount, maxTextCount } = characterLimits

  const isValidStory = isStoryValid(titleFieldValue, descriptionFieldValue)

  const isTitleOverLimit = titleFieldValue.length > maxTitleCount
  const isDescriptionOverLimit = descriptionFieldValue.length > maxTextCount

  const handleTitleChange = (e) => setTitleFieldValue(e.target.value)
  const handleDescriptionChange = (e) => setDescriptionFieldValue(e.target.value)

  useEffect(() => {
    setPendingEdits({
      ...pendingEdits,
      storyId,
      title: titleFieldValue,
      description: descriptionFieldValue,
      isValidStory,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps -- PendingEdits here will cause an infinte loop if added
  }, [setPendingEdits, titleFieldValue, descriptionFieldValue, storyId, isValidStory])

  useEffect(() => {
    setSaveHandler(() => () => {
      commitEdits()
    })
  }, [commitEdits, setSaveHandler])

  return (
    <>
      <TextField
        value={titleFieldValue}
        onChange={handleTitleChange}
        label={t('common-ui:title.item', 'Title')}
        warningValidate={() =>
          isTitleOverLimit ? t('EditStory.titleWarning.description', 'Title Exceeds Maximum Length') : ''
        }
        maxLength={maxTitleCount}
      />
      <MultilineTextField
        value={descriptionFieldValue}
        onChange={handleDescriptionChange}
        dense
        rows={6}
        label={t('TextPicker.textfield.label', 'Text')}
        warningValidate={() =>
          isDescriptionOverLimit ? t('EditStory.storyWarning.description', 'Story Exceeds Maximum Length') : ''
        }
        maxLength={maxTextCount}
        charactersRemainingLevel="always"
      />
      <Separator />
    </>
  )
}
